import type { DefaultTheme } from 'styled-components';

declare module 'styled-components' {
  export interface GraphPalettes {
    primary: string[];
    secondary: string[];
    tertiary: string[];
    quaternary: string[];
  }

  export interface DefaultTheme {
    title: 'light' | 'dark';
    colors: {
      primary: string;

      white: string;
      black: string;
      green: string;
      orange: string;
      yellow: string;
      red: string;
      blue: string;

      background: string;
      background1: string;

      content: string;
      content1: string;

      border: string;
      label: string;

      text: string;
      text1: string;
      text2: string;
      text3: string;
    };
    shapes: {
      borderRadius: string;
      boxShadow: string;
    };
    fontSizes: {
      verySmall: string;
      small: string;
      default: string;
      large: string;
      extraLarge: string;
    };
  }
}

const primary = '#28BEA5';

const neutralColors = {
  neutral1: '#646E6E',
  neutral2: '#8C9696',
  neutral3: '#B4BEBE',
  neutral4: '#F0F5F5',
};

const auxiliaryColors = {
  white: neutralColors.neutral4,
  black: neutralColors.neutral1,
  green: '#00BE14',
  orange: '#FF9100',
  yellow: '#FFC300',
  red: '#D2211D',
  blue: '#0087DC',
};

const fontSizes = {
  verySmall: '0.7rem',
  small: '0.9rem',
  default: '1rem',
  large: '1.1rem',
  extraLarge: '1.3rem',
};

const shapes = {
  borderRadius: '8px',
  boxShadow: '0px 2px 2px 2px rgba(0, 0, 0, 0.04)',
};

export const graphPalettes = {
  primary: ['#28BEA5', '#239687', '#FFC300', '#00BEFF', '#4BFF32', '#64666E'],

  secondary: ['#28BEA5', '#00EBB0', '#FFD22D', '#00E6FF', '#7DFF37', '#8C9696'],

  tertiary: ['#28BEA5', '#1EEED2', '#EFEB00', '#00FAFF', '#B45F14', '#B4BEBE'],

  quaternary: [
    '#28BEA5',
    '#25645A',
    '#F19203',
    '#4487DC',
    '#44BE14',
    '#3C4646',
  ],
};

export const graphPaletteKeys = Object.keys(graphPalettes);

export const lightTheme: DefaultTheme = {
  title: 'light',
  colors: {
    primary,
    ...auxiliaryColors,

    background: '#F9FDFC',
    background1: '#F0F5F4',

    content: '#ECF0EF',
    content1: '#E1EBE9',

    border: '#DADEE2',
    label: '#000000',

    text: neutralColors.neutral1,
    text1: neutralColors.neutral2,
    text2: neutralColors.neutral3,
    text3: neutralColors.neutral4,
  },
  shapes,
  fontSizes,
};

export const darkTheme: DefaultTheme = {
  title: 'dark',
  colors: {
    primary,
    ...auxiliaryColors,

    background: '#232E2E',
    background1: '#2D3838',

    content: '#2B3333',
    content1: '#586666',

    border: '#435252',
    label: '#ffffff',

    text: neutralColors.neutral4,
    text1: neutralColors.neutral3,
    text2: neutralColors.neutral2,
    text3: neutralColors.neutral1,
  },
  shapes,
  fontSizes,
};
